import { render } from "./wage-money-base-salary.vue?vue&type=template&id=0b51fa27"
import script from "./wage-money-base-salary.vue?vue&type=script&lang=js"
export * from "./wage-money-base-salary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-money-base-salary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b51fa27"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b51fa27', __exports__)) {
    api.reload('0b51fa27', __exports__)
  }
  
  module.hot.accept("./wage-money-base-salary.vue?vue&type=template&id=0b51fa27", () => {
    api.rerender('0b51fa27', render)
  })

}


export default __exports__